import {
	START_TRANSLATE_TEXTS,
	START_TRANSLATE_TEXTS_SUCCESS,
	START_TRANSLATE_TEXTS_FAILED,
} from './action-types';

export function translateTextsAction({ translateKey, languageCode, texts = [] }) {
	return {
		type: START_TRANSLATE_TEXTS,
		translateKey,
		languageCode,
		texts,
	};
}

export function translateTextsSuccessAction({
	translateKey,
	translatedTexts,
}) {
	return {
		type: START_TRANSLATE_TEXTS_SUCCESS,
		translateKey,
		translatedTexts,
	};
}

export function translateTextsFailedAction({
	error = null,
	errorMessage = '',
	translateKey,
} = {}) {
	return {
		type: START_TRANSLATE_TEXTS_FAILED,
		error,
		errorMessage,
		translateKey,
	};
}
